import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DefinitionDescription, DefinitionTerm, EyebrowText, LimitedSectionContent, Section, SectionHeadline } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { extendedMediaStrings, isExtraXLarge } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/media";
import { Accordion } from "@faire/retailer-visitor-shared/views/careers/__internal__/LifeatFaire/Accordion";
import { FAIRE_BENEFITS } from "@faire/retailer-visitor-shared/views/careers/__internal__/LifeatFaire/faireBenefits";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Row, Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useViewportWidth } from "@faire/web--source/ui/hooks/useViewportWidth";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import React, { useState } from "react";
import styled from "styled-components";
export var OurBenefitsSection = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(0), 2), openIndex = _useState[0], setOpenIndex = _useState[1];
    var _useViewport = useViewport(), isTabletAndAbove = _useViewport.isTabletAndAbove, isDesktopAndAbove = _useViewport.isDesktopAndAbove;
    var toggleAccordionItem = function(index) {
        if (openIndex === index) {
            setOpenIndex(undefined);
        } else {
            setOpenIndex(index);
        }
    };
    return /*#__PURE__*/ _jsx(Section, {
        $withHorizontalPadding: true,
        $withVerticalPadding: true,
        align: "center",
        id: "benefits",
        children: /*#__PURE__*/ _jsxs(LimitedSectionContent, {
            children: [
                /*#__PURE__*/ _jsx(Title, {}),
                isTabletAndAbove ? /*#__PURE__*/ _jsx(Column, {
                    align: isDesktopAndAbove ? "flex-end" : "flex-start",
                    children: /*#__PURE__*/ _jsx(Benefits, {})
                }) : /*#__PURE__*/ _jsx(Accordion, {
                    data: FAIRE_BENEFITS(strictLocalize),
                    openIndex: openIndex,
                    onItemClick: toggleAccordionItem
                })
            ]
        })
    });
};
var Benefits = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var benefitRows = [];
    var viewportWidth = useViewportWidth(function(width) {
        return width;
    });
    var columnSize = Math.floor(FAIRE_BENEFITS(strictLocalize).length / 2);
    for(var i = 0; i < columnSize; i++){
        benefitRows.push({
            left: FAIRE_BENEFITS(strictLocalize)[i],
            right: FAIRE_BENEFITS(strictLocalize)[i + columnSize]
        });
    }
    var standardSpacerSize = useResponsiveValue({
        mobileAndAbove: 0,
        tabletAndAbove: "9x",
        desktopAndAbove: "5x"
    });
    var spacerSize = isExtraXLarge(viewportWidth) ? "7x" : standardSpacerSize;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: benefitRows.map(function(row, index) {
            var _row_left, _row_left1, _row_right, _row_right1;
            var _row_left_title, _row_left_description, _row_right_title, _row_right_description;
            return /*#__PURE__*/ _jsxs(React.Fragment, {
                children: [
                    index === 0 ? null : /*#__PURE__*/ _jsx(Spacer, {
                        size: "5x"
                    }),
                    /*#__PURE__*/ _jsxs(BenefitsRow, {
                        children: [
                            /*#__PURE__*/ _jsx(Benefit, {
                                title: (_row_left_title = (_row_left = row.left) === null || _row_left === void 0 ? void 0 : _row_left.title) !== null && _row_left_title !== void 0 ? _row_left_title : "",
                                description: (_row_left_description = (_row_left1 = row.left) === null || _row_left1 === void 0 ? void 0 : _row_left1.description) !== null && _row_left_description !== void 0 ? _row_left_description : "",
                                number: String(index + 1).padStart(2, "0")
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: spacerSize
                            }),
                            /*#__PURE__*/ _jsx(Benefit, {
                                title: (_row_right_title = (_row_right = row.right) === null || _row_right === void 0 ? void 0 : _row_right.title) !== null && _row_right_title !== void 0 ? _row_right_title : "",
                                description: (_row_right_description = (_row_right1 = row.right) === null || _row_right1 === void 0 ? void 0 : _row_right1.description) !== null && _row_right_description !== void 0 ? _row_right_description : "",
                                number: String(index + 1 + columnSize).padStart(2, "0")
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
var TitleBase = function() {
    var regularBottomSpacer = useResponsiveValue({
        mobileAndAbove: "4x",
        tabletAndAbove: "5x",
        desktopAndAbove: "7x"
    });
    var viewportWidth = useViewportWidth(function(width) {
        return width;
    });
    var bottomSpace = isExtraXLarge(viewportWidth) ? 90 : regularBottomSpacer;
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            maxWidth: "450px"
        },
        children: [
            /*#__PURE__*/ _jsx(EyebrowText, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "IBCxta",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Our Benefits"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(SectionHeadline, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "19j2oc",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Some of the perks and experiences you\u2019ll have as an employee at Faire"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: bottomSpace
            })
        ]
    });
};
var Title = observer(TitleBase);
var BenefitBase = function(param) {
    var title = param.title, description = param.description, number = param.number;
    var viewport = useViewport();
    return /*#__PURE__*/ _jsxs(Row, {
        align: "flex-start",
        children: [
            viewport.isDesktopAndAbove ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subheadingSansMedium",
                        children: number
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "2x"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsxs("dl", {
                children: [
                    /*#__PURE__*/ _jsx(BenefitTitle, {
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    }),
                    /*#__PURE__*/ _jsx(BenefitDescription, {
                        children: description
                    })
                ]
            })
        ]
    });
};
var Benefit = observer(BenefitBase);
var BenefitsRow = styled.div.withConfig({
    componentId: "sc-c7e1312-0"
})([
    "display:flex;flex-direction:row;justify-content:space-between;",
    "{justify-content:center;}"
], responsiveMediaQueries.tablet);
var BenefitTitle = styled(DefinitionTerm).withConfig({
    componentId: "sc-c7e1312-1"
})([
    "width:100%;",
    "{width:346px;}"
], responsiveMediaQueries.desktopAndAbove);
var BenefitDescription = styled(DefinitionDescription).withConfig({
    componentId: "sc-c7e1312-2"
})([
    "width:260px;",
    "{width:346px;}"
], extendedMediaStrings.extraxlarge);
